module.exports = __webpack_public_path__ + "img/btn_speak.b88dafce.png";